/**
 * One delegation's narrator lines — open while the job runs, folded afterwards.
 *
 * `<details>` rather than a button and a piece of state: the open/closed
 * behaviour is the element's own, it keeps working with JavaScript busy, and it
 * is what a keyboard and a screen reader already know. `open` is set from the
 * group rather than controlled — React re-renders it when the answer arrives and
 * the group closes, and a visitor who opens it again is not fought with on the
 * next render, because nothing here writes back.
 */

import type { ThreadItem } from './progressGroups';
import { progressSummary } from './progressGroups';
import { stripEmoji as plain } from '../lib/emoji';

function Lines({ lines }: { lines: { id: string; text: string }[] }) {
  return (
    <>
      {lines.map((line) => (
        <p className="progress__line" key={line.id}>
          {plain(line.text)}
        </p>
      ))}
    </>
  );
}

export default function ProgressGroup({ group }: { group: Extract<ThreadItem, { kind: 'progress' }> }) {
  const lines = group.lines.map((bubble) => ({ id: bubble.id, text: bubble.text }));
  if (!group.collapsed) {
    return (
      <div className="progress progress--open">
        <Lines lines={lines} />
      </div>
    );
  }
  return (
    <details className="progress progress--done">
      <summary className="progress__summary">{progressSummary(lines.length)}</summary>
      <Lines lines={lines} />
    </details>
  );
}
